<template>
    <div class="col-lg-12">
        <table-search-and-pagination
            :per-page="perPage"
            :current-page="currentPage"
            :virtual-total="total"
            :table-data="receiptLogs"
            :query="routeQuery"
            :custom-search="true"
            @perPageUpdated="$emit('perPageUpdated', $event)"
            @dataUpdated="queriedData = $event"
            @queryUpdated="queryUpdated"
            @changedPage="$emit('changedPage', $event)"
        >
            <div slot="header">
                <div class="flex-between">
                    <div class="flex-between">
                        <base-button
                            class="mr-5"
                            type="info"
                            @click="showQuoteCalculator = true"
                        >
                            <i class="fa fa-calculator mr-1" />
                            Quote Calculator
                        </base-button>
                        <base-button
                            class="mr-2"
                            :disabled="selectedReceiptLogs.length === 0"
                            type="primary"
                            @click="requestDelivery"
                        >
                            Request Delivery
                            <span v-if="selectedReceiptLogs.length > 0">
                                ({{ selectedReceiptLogs.length }})
                            </span>
                        </base-button>
                        <base-button
                            :disabled="selectedReceiptLogs.length === 0"
                            type="info"
                            @click="calculateStorageCost"
                        >
                            Calculate Storage Cost
                            <span
                                v-if="selectedReceiptLogs.length > 0"
                                class="ml-1"
                            >
                                ({{ selectedReceiptLogs.length }})
                            </span>
                        </base-button>
                    </div>
                </div>
                <h5 class="card-category">
                    Showing records from {{ lastYear }} - {{ today }}
                </h5>
            </div>
            <receipt-logs-table
                :receipt-logs="queriedData"
                :exclude-columns="excludedColumns"
                :exclude-available-when-zero="excludeAvailableWhenZero"
                :clear-selection="clearSelection"
                @changeExcludeAvailableWhenZero="changeExcludeAvailableWhenZero"
                @selectionChange="selectedReceiptLogs = $event"
            />
        </table-search-and-pagination>
        <storage-cost-modal
            v-if="calculateStorageReceiptLogIds.length"
            :show.sync="showStorageCostModal"
            :receipt-log-ids="calculateStorageReceiptLogIds"
        />
        <quote-calculator
            v-if="showQuoteCalculator"
            @close="showQuoteCalculator = false"
        />
    </div>
</template>
<script>
import _ from "lodash";
import moment from "moment-timezone";
import TableSearchAndPagination from "src/components/TableSearchAndPagination";
import ReceiptLogsTable from "./ReceiptLogsTable.vue";
import StorageCostModal from "./StorageCostModal.vue";
import QuoteCalculator from "../../QuoteCalculator";

export default {
    name: "ReceiptLogs",
    components: {
        ReceiptLogsTable,
        TableSearchAndPagination,
        StorageCostModal,
        QuoteCalculator,
    },
    props: {
        receiptLogs: {
            type: Array,
            required: true,
        },
        total: {
            type: Number,
            required: true,
        },
        currentPage: {
            type: Number,
            required: true,
        },
        perPage: {
            type: Number,
            required: true,
        },
        routeQuery: {
            type: String,
            default: "",
        },
        excludeAvailableWhenZero: {
            type: Boolean,
            required: true,
        },
        excludedColumns: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            clearSelection: false,
            showRequestDeliveryModal: false,
            showQuoteCalculator: false,
            selectedReceiptLogs: [],
            queriedData: [],
            showStorageCostModal: false,
            calculateStorageReceiptLogIds: [],
        };
    },
    computed: {
        lastYear() {
            return moment().subtract(1, "years").format("MM/DD/YYYY");
        },
        today() {
            return moment().format("MM/DD/YYYY");
        },
    },
    methods: {
        changeExcludeAvailableWhenZero(value) {
            this.$emit("changeExcludeAvailableWhenZero", value);
        },
        requestDelivery() {
            this.$emit("requestDelivery", this.selectedReceiptLogs);
            this.selectedReceiptLogs = [];
        },
        calculateStorageCost() {
            this.showStorageCostModal = true;
            this.calculateStorageReceiptLogIds = this.selectedReceiptLogs.map(
                (log) => log.id,
            );
            this.selectedReceiptLogs = [];
        },
        // debounce the search query to once every half second to speed up database search
        queryUpdated: _.debounce(
            async function updated(query) {
                this.$emit("search", query);
            },
            500,
            { trailing: true },
        ),
    },
    watch: {
        selectedReceiptLogs(logs) {
            this.clearSelection = !logs.length;
        },
    },
};
</script>
